import React, { useState, useEffect } from "react";
import { Col, Card, CardBody, Button } from "reactstrap";
import { getRecords } from "../../services/api.service";
import { useNavigate } from "react-router-dom";

const ProjectWarehouseStock = () => {
  const navigate = useNavigate();
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isFetch, setIsFetch] = useState(false);

  const skeletonStyle = {
    backgroundColor: "#f0f0f0",
    borderRadius: "4px",
    position: "relative",
    overflow: "hidden",
    background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
    backgroundSize: "200% 100%",
    animation: "shimmer 1.5s infinite linear",
  };

  useEffect(() => {
    let timer;

    const fetchData = async () => {
      if (!isFetch) {
        setLoading(true);
        await fetchReports();
        setLoading(false);
      }
    };

    timer = setTimeout(fetchData, 3000);

    const handleStorageChange = () => {
      fetchReports();
      setIsFetch(true);
    };

    window.addEventListener("dashboardUpdate", handleStorageChange);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("dashboardUpdate", handleStorageChange);
    };
  }, [isFetch]);

  const fetchReports = async () => {
    try {
      const dashboard_details = localStorage.getItem("dashboard_details");
      if (!dashboard_details) {
        // Set default skeleton data if no localStorage
        setReports([
          { id: 1, title: "Number of Projects", value: "0" },
          { id: 2, title: "Number of Warehouses", value: "0" },
          { id: 3, title: "Available Stock", value: "0" },
        ]);
        return;
      }

      const payload = JSON.parse(dashboard_details);
      const response = await getRecords(
        payload,
        "/dashboard/getDashboardSummary"
      );

      if (response?.code === 1) {
        const formattedData = response.data.map((report) => {
          if (payload?.type == "qty" && report?.id == 3) {
            // Assuming id:3 is the cost field
            return {
              ...report,
              value: formatCostValue(report.value),
            };
          }
          return report;
        });

        setReports(formattedData);
      }
    } catch (error) {
      console.error("Error fetching reports:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDetails = (id) => {
    const routes = {
      1: "/project-details",
      2: "/warehouse-details",
      3: "/available-stocks",
    };
    if (routes[id]) navigate(routes[id]);
  };

  const formatCostValue = (value) => {
    if (!value) return value;

    if (
      /[₹LK,]/.test(value) ||
      isNaN(parseFloat(value.replace(/[^0-9.]/g, "")))
    ) {
      return value;
    }

    // Convert to number and format with commas
    const numericValue = parseFloat(value.toString().replace(/,/g, ""));
    return numericValue.toLocaleString("en-IN");
  };

  return (
    <React.Fragment>
      <style>
        {`
          @keyframes shimmer {
            to { background-position: -200% 0; }
          }
        `}
      </style>

      {loading
        ? [...Array(3)].map((_, index) => (
            <Col key={`skeleton-${index}`}>
              <Card>
                <CardBody>
                  <div className="d-flex">
                    <div className="flex-1 overflow-hidden">
                      <div
                        style={{
                          ...skeletonStyle,
                          width: "150px",
                          height: "20px",
                          marginBottom: "12px",
                        }}
                      />
                      <div
                        style={{
                          ...skeletonStyle,
                          width: "80px",
                          height: "24px",
                        }}
                      />
                    </div>
                  </div>
                  <div className="d-flex justify-content-end">
                    <div
                      style={{
                        ...skeletonStyle,
                        width: "80px",
                        height: "20px",
                      }}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          ))
        : // Actual Content
          reports?.map((report, key) => (
            <Col key={key}>
              <Card>
                <CardBody>
                  <div className="d-flex">
                    <div className="flex-1 overflow-hidden">
                      <p className="text-truncate font-size-14 mb-3 fw-bold">
                        {report.title}
                      </p>
                      <h4 className="mb-0"> {report?.value}</h4>
                    </div>
                  </div>
                  <div className="d-flex justify-content-end">
                    <Button
                      color="link"
                      className="d-flex align-items-center justify-content-center fw-bold p-0 text-decoration-none"
                      onClick={() => handleDetails(report.id)}>
                      Details
                      <i className="ri-arrow-right-line fs-5 ms-1"></i>
                    </Button>
                  </div>
                </CardBody>
              </Card>
            </Col>
          ))}
    </React.Fragment>
  );
};

export default ProjectWarehouseStock;
